import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Portal from 'modules/core/components/Portal'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import FileViewer from './FileViewer'
import PictureInfo from './PictureInfo'
import * as styles from './index.vanilla.css'

interface Props {
  clockPicture: ClockPicture
  employeeFullName: string
  onClose: () => void
}

const ClockPicturePreview = ({ clockPicture, employeeFullName, onClose }: Props) => {
  return (
    <Portal onClose={onClose}>
      <div className={styles.modal}>
        <div className={styles.box}>
          <div className={styles.body}>
            <div className={styles.file}>
              <Box flexGrow alignItems="center" justifyContent="center">
                <FileViewer clockPicture={clockPicture} />
              </Box>
            </div>
            <Box>
              <PictureInfo
                clockPicture={clockPicture}
                employeeFullName={employeeFullName}
                onClose={onClose}
              />
            </Box>
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default observer(ClockPicturePreview)
